
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./rdweb-sdk.cjs.production.min.js')
} else {
  module.exports = require('./rdweb-sdk.cjs.development.js')
}
